import { Dispatch } from '@reduxjs/toolkit'

import { doesDateOverlapWithPeriod } from '@/entities/Period/PeriodHelpers'
import { getLoketLeaveBalance } from '@/helpers/api-ts/loketLeaveBalance'
import { differenceInDays } from '@/helpers/date'
import { PayrollPeriod } from '@/models'
import {
    ABSENCES_GET_CURRENT_PAYROLL_PERIOD_FAILURE,
    ABSENCES_GET_CURRENT_PAYROLL_PERIOD_REQUEST,
    ABSENCES_GET_CURRENT_PAYROLL_PERIOD_SUCCESS,
    ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_FAILURE,
    ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_REQUEST,
    ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_SUCCESS,
} from '@/redux/actionTypes'
import { Reducers } from '@/redux/reducers'

export const getCurrentPayrollPeriod = () => (dispatch: Dispatch, getState: () => Reducers): void => {
    dispatch({ type: ABSENCES_GET_CURRENT_PAYROLL_PERIOD_REQUEST })

    try {
        const { payrollPeriods } = getState().appReducer

        const currentDate = new Date()
        const matchingPayrollPeriod = payrollPeriods
            .find((payrollPeriod: PayrollPeriod) => doesDateOverlapWithPeriod(currentDate, { start: payrollPeriod.start, end: payrollPeriod.end.date }))

        const sortedPayrollPeriods = [...payrollPeriods].sort(
            (payrollPeriodA: PayrollPeriod, payrollPeriodB: PayrollPeriod) => {
                if (Math.abs(differenceInDays(payrollPeriodB.start, currentDate))
                    < Math.abs(differenceInDays(payrollPeriodA.start, currentDate))) {
                    return 1
                }

                return -1
            },
        )

        dispatch({
            type: ABSENCES_GET_CURRENT_PAYROLL_PERIOD_SUCCESS,
            currentPayrollPeriod: matchingPayrollPeriod || sortedPayrollPeriods[0],
        })
    } catch (error) {
        console.error(error)
        dispatch({ type: ABSENCES_GET_CURRENT_PAYROLL_PERIOD_FAILURE })
    }
}

export const getEmployeeLoketBalances = (loketEmployeeId: string) => async (dispatch: Dispatch): Promise<void> => {
    dispatch({ type: ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_REQUEST })

    try {
        const loketLeaveBalance = await getLoketLeaveBalance(loketEmployeeId)

        dispatch({ type: ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_SUCCESS, loketLeaveBalance })
    } catch {
        dispatch({ type: ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_FAILURE })
    }
}
